export default __webpack_public_path__ + "static/media/invoiceBgImg.5dfe24ba.png";